import { ExperienceGate as SharedExperienceGate } from '@cascade/react/experiences';
import { useI18n } from '@cascade/react/i18n';
import { Loading } from '@cascade/ui-library';
import type { PropsWithChildren } from 'react';
import { ExperienceConsent } from '#views/experience-consent/index.ts';
import { ExperienceFailed } from '#views/experience-failed/index.ts';

export const ExperienceGate = ({ children }: PropsWithChildren) => {
  const { translate } = useI18n();

  return (
    <SharedExperienceGate
      loading={<Loading contain label={translate('pending.experience')} />}
      failed={<ExperienceFailed />}
      unconsented={<ExperienceConsent />}
    >
      {children}
    </SharedExperienceGate>
  );
};
